import '@hotwired/turbo'
import '@tailwindplus/elements'
import { createApp } from 'vue'

// Update sidebar nav active states
function updateNavActiveStates() {
  const path = window.location.pathname

  // Desktop sidebar
  document.querySelectorAll('#desktop-sidebar .nav-link').forEach(link => {
    const navPath = link.dataset.navPath
    const isActive = navPath && path.startsWith(navPath)
    link.classList.toggle('bg-white/5', isActive)
    link.classList.toggle('text-white', isActive)
    link.classList.toggle('text-gray-400', !isActive)
  })

  // Mobile sidebar
  document.querySelectorAll('#mobile-sidebar .nav-link').forEach(link => {
    const navPath = link.dataset.navPath
    const isActive = navPath && path.startsWith(navPath)
    link.classList.toggle('bg-gray-800', isActive)
    link.classList.toggle('text-white', isActive)
    link.classList.toggle('text-gray-400', !isActive)
  })
}

document.addEventListener('turbo:load', updateNavActiveStates)
document.addEventListener('turbo:render', updateNavActiveStates)

// Simple tabs handler
function initTabs() {
  document.querySelectorAll('[data-tabs]').forEach(container => {
    const tabs = container.querySelectorAll('[data-tab-button]')
    const panels = container.querySelectorAll('[data-tab-panel]')

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tabButton

        tabs.forEach(t => {
          const isActive = t.dataset.tabButton === targetTab
          t.classList.toggle('bg-white', isActive)
          t.classList.toggle('text-gray-900', isActive)
          t.classList.toggle('bg-gray-50', !isActive)
          t.classList.toggle('text-gray-500', !isActive)
        })

        panels.forEach(panel => {
          panel.classList.toggle('hidden', panel.dataset.tabPanel !== targetTab)
        })
      })
    })
  })
}

document.addEventListener('turbo:load', initTabs)
document.addEventListener('DOMContentLoaded', initTabs)

// Auto-mount Vue components on elements with data-vue-component attribute
document.addEventListener('DOMContentLoaded', () => {
  const vueElements = document.querySelectorAll('[data-vue-component]')

  vueElements.forEach(async (el) => {
    const componentName = el.dataset.vueComponent
    const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}

    try {
      const module = await import(`~/components/${componentName}.vue`)
      const app = createApp(module.default, props)
      app.mount(el)
    } catch (e) {
      console.error(`Failed to load component: ${componentName}`, e)
    }
  })
})
